import React, { useEffect } from "react";
import propTypes from "prop-types";
// import { Card } from "primereact/card";
import StyleWrapper from "./style";
import { RadioButton } from "primereact/radiobutton";
// import config from "../../../../helpers/config";
import { useTranslation } from "react-i18next";
import tamara from "assets/images/tamara.svg";
import { BUSINESS_LINE_COLORS } from "helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { SAVE_TOTAL_PRICE } from "redux/actions/motorActions";

const ProductCard = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  let clickTimer = null;
  useEffect(()=>{
    dispatch(SAVE_TOTAL_PRICE(props.price))
  }, [props.price, dispatch])

  const handleClick = () => {
    clearTimeout(clickTimer);
    props.onSelect();
    dispatch(SAVE_TOTAL_PRICE(props.price));

    clickTimer = setTimeout(() => {
      props.onSelect();
      dispatch(SAVE_TOTAL_PRICE(props.price));
      clearTimeout(clickTimer);
    },1)
  };
  
 if (window.innerWidth <= 600) {
  return (
   <StyleWrapper
    className={
     "mobile_product_card" +
     (props.showChip ? " mobile_product_card_chip" : "") +
     (props.isActive ? " active" : "") +
     (i18n.resolvedLanguage === "ar" ? " mobile_product_card_ar" : "")
    }
      onClick={handleClick}
    businessColor={props.businessColor}
   >
    <div className={`mpc_div ${props.isActive ? "mpc_div_active" : ""}`}>
     <div className="mpc_div_top">
      <h4 className={`title ${i18n.resolvedLanguage !== "ar" ? 'fm-bliss2-bold': ''}`}>{props.title}</h4>
      {+props.priceBefore>0 && <p className="beforeDiscount">{(props.priceBefore * 1.15).toFixed(2)}</p>}
      <div className="mpc_div_top_price">
       <h3 className="text-900 text-xl price fm-tawuniya">&nbsp;{props.price}</h3>
       <span className="mx-1">{t("POLICY.SAR")}</span>
       <p className="text-xs m-0">{t("MotorEn.Icluding_vat")}</p>
      </div>
     </div>
    
     <hr />
     <p className={`sub-title smaller ${i18n.resolvedLanguage === "ar" ? "fm-tawuniya" : ""}`}>
     {props.subTitle}
        {props.par}
      </p>

      {props.businessLine !== 'bsf' && props.businessLine !== 'snb' && (
     <div className="mpc_div_bottom">
      <span className="mpcdb_text">
       {t("Motor.split_with_tamara")}
       &nbsp;{t("Motor.with")}&nbsp;
      </span>
      <img src={tamara} />
     </div>
     )}
    </div>
    {props.isActive && props.showActiveCtx && (
     <div className="mpc_active">
      <div>
       <p className="mpc_active_txt">
        {props.title} {t("Motor.basic_covers")}
       </p>
      </div>
      <div className="mpc_active_tags_wrap">
       <div className="mpc_active_tags">
        {props.activeCtx.map((item, idx) => {
         return (
          <div key={idx} className="mpc_active_tag">
           <img src={item.icon} />
           <p className="mpc_active_txt">{t(item.text)}</p>
          </div>
         );
        })}
       </div>
      </div>
     </div>
    )}
    {props.businessLine !== 'bsf' && props.businessLine !== 'snb' && (Boolean(props.showChip)) && (
     <div className="mpc_chip">
      <div className="mpc_chip_drive">
       <p>{t("Motor.drive")}</p>
      </div>
      <div className="mpc_chip_txt">
       <p> <span className="fm-tawuniya"> 1000 </span>{t("Motor.cashback")}</p>
      </div>
     </div>
    )}

{props.isRecommended && (
    <div className="recomended">
   
     <div className="mpc_chip_txt">
      <p><span className="fm-tawuniya">{t("Motor.Recomended")} </span></p>
     </div>
    </div>
   )}
   </StyleWrapper>
  );
 }


  return (
    <StyleWrapper
      className={
        props.className +
        " d-flex flex-column align-items-start mpc_chip_wrap_div" +
        (props.isActive ? " active" : "") +
        (props.isSmall ? " small_card" : "")
      }
      onClick={handleClick}
      businessColor={props.businessColor}
    >
      <h4 className="title fm-bliss2-bold">{props.title}</h4>
      <p className={`sub-title ${i18n.resolvedLanguage !== "ar" && "fm-bliss2-bold"}`}>
        {props.subTitle}
      </p>
      <p className={`sub-title smaller ${i18n.resolvedLanguage === "ar" ? "fm-tawuniya" : ""}`}>
        {props.par}
      </p>

      <div className="actions d-flex justify-content-between align-items-center w-100 ">
        <div className="d-flex flex-column align-items-start">
          {!props.isSmall && <p className="text-sm m-0">{t("POLICY.TOTAL")}</p>}
          
      {+props.priceBefore>0 && <p className="beforeDiscount">{(props.priceBefore * 1.15).toFixed(2)}</p>}
     <div className="d-flex align-items-center">
      <h3 className="text-900 text-xl price fm-tawuniya">{props.price}</h3>
      <span className="mx-1">{t("POLICY.SAR")}</span>
     </div>
     {/* <p className="text-xs m-0">+ {props.vat} SAR VAT</p> */}
     {!props.isSmall && <p className={`text-xs m-0 ${i18n.resolvedLanguage !== "ar" && 'fm-bliss2-bold'}`}>{t("MotorEn.Icluding_vat")}</p>}
     {props.businessLine !== 'bsf' && props.businessLine !== 'snb' && (
     <div className="mpc_div_bottom">
      <span className="mpcdb_text">
       {t("Motor.split_with_tamara")}
       &nbsp;{t("Motor.with")}&nbsp;
      </span>
      <img src={tamara} />
     </div>
     )}
    </div>
    <RadioButton checked={props.isActive} />
   </div>
   {props.businessLine !== 'bsf' && props.businessLine !== 'snb' && (Boolean(props.showChip)) && (
    <div className="mpc_chip">
     <div className="mpc_chip_drive">
      <p>{t("Motor.drive")}</p>
     </div>
     <div className="mpc_chip_txt">
      <p><span className="fm-tawuniya"> 1000 </span>{t("Motor.cashback")}</p>
     </div>
    </div>
   )}

{props.isRecommended && (
    <div className="recomended">
   
     <div className="mpc_chip_txt">
      <p><span className="fm-tawuniya">{t("Motor.Recomended")} </span></p>
     </div>
    </div>
   )}
  </StyleWrapper>
 );
};

ProductCard.propTypes = propTypes.exact({
  title: propTypes.string.isRequired,
  subTitle: propTypes.string,
  price: propTypes.string.isRequired,
  vat: propTypes.string,
  onSelect: propTypes.func.isRequired,
  isRecommended: propTypes.bool,
  isActive: propTypes.bool.isRequired,
  className: propTypes.string,
}).isRequired;

export default ProductCard;
